/* Version: 3.5.155 */
'use client';
var MESSAGE_VARIANT = {
  PRIMARY_INFORMATION: 'primary_information',
  PRIMARY_WARNING: 'primary_warning',
  PRIMARY_ALERT: 'primary_alert',
  PRIMARY_COMPLETE: 'primary_complete',
  SECONDARY_INFORMATION: 'secondary_information',
  SECONDARY_WARNING: 'secondary_warning',
  SECONDARY_ALERT: 'secondary_alert',
  SECONDARY_COMPLETE: 'secondary_complete',
  HARDSTOP: 'hardstop'
};

export { MESSAGE_VARIANT };
